import { createReducer } from '@reduxjs/toolkit';
import { FullscreenPreviewShape } from './model';
import * as fullscreenPreviewActions from './actions';

const initial: FullscreenPreviewShape = {
  singleAssetId: null,
  singleAsset: null,
  singleAssetError: false,
};

export const fullscreenPreviewReducer = createReducer<FullscreenPreviewShape>(initial, (builder) =>
  builder
    .addCase(fullscreenPreviewActions.assetIdChanged, (s, a) => {
      s.singleAssetId = a.payload.id;
    })
    .addCase(fullscreenPreviewActions.assetChanged, (s, a) => {
      s.singleAsset = a.payload.asset;
      s.singleAssetError = a.payload.error;
    }),
);
